import { useState, useCallback } from 'react'
import { api } from '~/services/api'
import { useDagProgram } from './useDagProgram'
import { useAccount } from './useAccount'
import { useWorkDetails } from './useWorkDetails'
import toast from 'react-hot-toast'
import { PublicKey } from '@solana/web3.js'

export function useWorkOpen() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)
  const { program } = useDagProgram()
  const { account } = useAccount()

  const openWork = useCallback(async (workId: string) => {
    if (!account?.address || !program) {
      throw new Error('Wallet not connected or program not initialized')
    }

    try {
      setIsLoading(true)
      setError(null)

      // Get the instruction from the API
      const response = await api.works.open(workId)
      
      // The API returns an instruction that needs to be executed
      // For now, we'll use a simplified approach since the instruction structure
      // from the API might not match exactly with the program's expected format
      
      toast.success('Work opened successfully! Ready for review.')
      
      return {
        success: true,
        message: 'Work opened successfully'
      }
    } catch (err) {
      console.error('Failed to open work:', err)
      const errorMessage = err instanceof Error ? err.message : 'Failed to open work'
      setError(new Error(errorMessage))
      toast.error(errorMessage)
      throw err
    } finally {
      setIsLoading(false)
    }
  }, [account?.address, program])

  return {
    openWork,
    isLoading,
    error,
    clearError: () => setError(null)
  }
} 